import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useUpdateLiveStreamPostMutation = createMutationHook(
  MembershipsCreatorV2ApiClient.updateLiveStreamPost,
  {
    mutationKey: ['updateLiveStreamPost'],
  },
)
